// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3HLK3","dragIcon":"SortableItem_dragIcon__tMdVS","disabled":"SortableItem_disabled__2Mgw4"};